export enum UserRole {
  Limited = 1,
  AccountAdmin = 2,
  Admin = 3,
}
